import React, { useEffect, useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from './ui/sheet';
import { Share, Plus, Smartphone, X } from 'lucide-react';

const isIOSSafari = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent || '';
  const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
  return iOS && isSafari;
};
const isStandalone = () => typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);

const InstallNudge = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!isIOSSafari() || isStandalone()) return;
    try {
      const dismissed = localStorage.getItem('cs_install_dismissed_at');
      if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 3600 * 1000) return; // suppress for 7 days after dismiss
      const raw = localStorage.getItem('cs_visits') || '0';
      const count = parseInt(raw) + 1;
      localStorage.setItem('cs_visits', String(count));
      if (count >= 3) setTimeout(() => setOpen(true), 1500);
    } catch (e) { /* ignore */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem('cs_install_dismissed_at', String(Date.now())); } catch (e) { /* ignore */ }
    setOpen(false);
  };

  return (
    <Sheet open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <SheetContent side="bottom" className="rounded-t-3xl border-t-0">
        <SheetHeader className="text-left">
          <div className="flex items-center gap-3 mb-1">
            <div className="w-11 h-11 rounded-2xl bg-emerald-100 text-emerald-700 grid place-items-center"><Smartphone className="w-5 h-5" /></div>
            <div>
              <SheetTitle className="font-display text-lg text-emerald-950">Add CalorieSnap to your Home Screen</SheetTitle>
              <SheetDescription className="text-sm">Faster access and it works offline for logging.</SheetDescription>
            </div>
          </div>
        </SheetHeader>
        <ol className="mt-4 space-y-3">
          <li className="flex items-start gap-3"><span className="w-7 h-7 rounded-full bg-emerald-700 text-white grid place-items-center text-sm font-bold shrink-0">1</span><div><p className="text-emerald-950 font-medium">Tap the Share button</p><p className="text-emerald-950/60 text-sm mt-0.5 inline-flex items-center gap-1">Look for <Share className="w-3.5 h-3.5" /> at the bottom</p></div></li>
          <li className="flex items-start gap-3"><span className="w-7 h-7 rounded-full bg-emerald-700 text-white grid place-items-center text-sm font-bold shrink-0">2</span><div><p className="text-emerald-950 font-medium">Choose “Add to Home Screen”</p><p className="text-emerald-950/60 text-sm mt-0.5 inline-flex items-center gap-1">Tap the <Plus className="w-3.5 h-3.5" /> option, then Add</p></div></li>
        </ol>
        <button onClick={dismiss} className="mt-5 w-full text-center text-emerald-950/60 text-sm py-2">Not now</button>
      </SheetContent>
    </Sheet>
  );
};

export default InstallNudge;
